import { vars, log } from '../base/variables';
import { loadPosts } from './load-posts';
const initpostsFilters = ( wrapper ) => {
    // const posts = wrapper.querySelector('#posts-by-categories');
    const filters = wrapper.querySelectorAll('.select-items div');
    const loadMoreBtn = wrapper.querySelector('.load-more-posts');
    const termInUrl = vars.url.indexOf('#');
    // const currentSubmenuLinks = document.querySelectorAll('#primary-menu > li.current_page_item .sub-menu a');
    const hash = window.location.hash;
    
    let maxpages;
    let filtered = false;
    let categories = '';
    let pageNr = 1;
    let activeFilters = [];

    const remove = (array, element) => {
        const index = array.indexOf(element);
        if (index !== -1) {
            array.splice(index, 1);
        }
    }

    const filterFromUrl = (str) => {
        activeFilters = [];
        let terms = str.substring(str.indexOf('#') + 1, str.length);
        let termsArray = terms.split('&');
        filters.forEach((f) => {
            // f.checked = false;
            termsArray.forEach((t) => {
                if ( f.id === t + '-cat' ) {
                    var selected = document.getElementsByClassName('select-selected')[0];
                    selected.innerHTML = f.innerHTML;
                    selected.id = f.id;
                    selected.setAttribute('value' , f.getAttribute('value'));
                    selected.setAttribute('data-id' , f.getAttribute('data-id'));
                    // f.checked = true;
                }
            });
        });
        load_checked_filters(termsArray);
    }

    const load_checked_filters = (url) => {
        // watch the checked filters on page load
        if ( filters ) {
            filters.forEach((filter) => {
                pageNr = 1;
                // first get new filters
                const data = filter.getAttribute('data-id');
                // Change active Filters
                if (activeFilters.indexOf(data) == -1) {
                    if (url) {
                        if (url.indexOf(data) != -1) {
                            activeFilters.push(data);
                        } else {
                            remove(activeFilters, data);
                        }
                    } else {
                        activeFilters.push(data);
                    }
                } else {
                    remove(activeFilters, data);
                }
                categories = activeFilters.join();
                // make sure everything is checked in the time
                setTimeout( () => { loadPosts(wrapper, categories, false, 1) }, 50);
            });
        }
    }

    // // First action:
    load_checked_filters();    
    
    // Check # on page load only)
    if (termInUrl !== -1) {
        filterFromUrl(vars.url);
    }
    
    filters.forEach((filter) => {
        filter.addEventListener('click', (e) => {
            e.stopPropagation();
            pageNr = 1;
            // Get new filters
            const data = filter.getAttribute('data-id');
            // Change active Filters
            // if (activeFilters.indexOf(data) == -1) {
            //     activeFilters.push(data);
            // } else {
            //     remove(activeFilters, data);
            // }
            if (data == 'all') {
                activeFilters = [];
                filters.forEach((filter) => {
                    let aux = filter.getAttribute('data-id');
                    activeFilters.push(aux);
                });
            } else {
                activeFilters = [data];
            }
            // Change Location #
            let hashStr = '';
            if (activeFilters.length > 0) {
                for( let i in activeFilters ) {
                    if ( i == 0) {
                        hashStr += activeFilters[i];
                    } else {
                        hashStr += '&' + activeFilters[i];
                    }
                    if (hashStr.indexOf('all&') == -1) {
                        window.location.hash = hashStr;
                    } else{
                        window.location.hash = 'all';
                    }
                }
            } else {
                window.location.hash = '';
            }

            categories = activeFilters.join();
            loadPosts(wrapper, categories, false, pageNr);
        });
    });

    if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const max = loadMoreBtn.getAttribute('data-maxpages');
            if (pageNr < max) {
                pageNr++;
                // console.log(categories, max, pageNr);
                loadPosts(wrapper, categories, true, pageNr);
            }
        });
    }
}

export { initpostsFilters };